import { useEffect, useState } from "react";
import { MessageCircleQuestion, FileText } from "lucide-react";
import api from "../lib/api";
import { DataRoomCard } from "./dataroom/DataRoomCard";
import { t } from "../lib/i18n";

export default function SellerQuestions({ company }) {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    api.get(`/companies/${company.company_id}/dataroom`)
      .then((r) => setSummary({
        open: r.data.questions.filter((q) => q.status !== "answered").length,
        total: r.data.questions.length,
        docs: r.data.documents.length,
      }))
      .catch(() => setSummary(null));
  }, [company.company_id]);

  return (
    <div className="space-y-5" data-testid="seller-questions-panel">
      <DataRoomCard companyId={company.company_id} stage={company.stage} isOwner />
      {summary && (
        <div className="grid sm:grid-cols-3 gap-0 hairline border-r-0 border-b-0" data-testid="seller-dataroom-summary">
          <Kpi icon={MessageCircleQuestion} label={t("Preguntas pendientes")} value={summary.open} accent={summary.open > 0} />
          <Kpi icon={MessageCircleQuestion} label={t("Preguntas totales")} value={summary.total} />
          <Kpi icon={FileText} label={t("Documentos publicados")} value={summary.docs} />
        </div>
      )}
      <p className="text-sm text-muted-foreground">
        {t("Esta etapa se marca como completada en cuanto respondes tu primera pregunta en el Data Room.")}
      </p>
    </div>
  );
}

const Kpi = ({ icon: Icon, label, value, accent }) => (
  <div className="hairline border-l-0 border-t-0 p-5 bg-card flex items-center gap-4">
    <Icon className={`w-4 h-4 ${accent ? "text-[#E0712C]" : "text-muted-foreground"}`} />
    <div>
      <div className={`font-serif-display text-2xl ${accent ? "text-[#E0712C]" : ""}`}>{value}</div>
      <div className="font-mono-label text-muted-foreground" style={{ fontSize: "0.58rem" }}>{label}</div>
    </div>
  </div>
);
